import { BRAND, TIERS, YARD_SIGN_OPTIONS } from "../constants";
import { INPUT_STYLE, LABEL_STYLE } from "../styles/shared.js";

export default function TierSelection({ tier, yardSign, onTierChange, onYardSignChange }) {
  return (
    <div>
      <h2 style={{ fontFamily: "'Playfair Display', serif", fontSize: "20px", margin: "0 0 4px", color: "#1A1A1A", fontWeight: 800 }}>
        Choose Your Donation Level
      </h2>
      <p style={{ fontSize: "13px", color: "#888", margin: "0 0 20px" }}>
        Your donation supports DEF programs for City Schools of Decatur.
      </p>
      {TIERS.map(function(t) {
        var selected = tier.id === t.id;
        return (
          <div
            key={t.id}
            onClick={function() { onTierChange(t); }}
            style={{
              background: selected ? BRAND.primaryLight : "#FAFAF7",
              border: selected ? "2px solid " + BRAND.primary : "1.5px solid #EEE",
              borderRadius: "8px",
              padding: "18px 20px",
              marginBottom: "10px",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              gap: "14px",
              transition: "all 0.15s",
            }}
          >
            <div style={{
              width: "22px", height: "22px", borderRadius: "50%",
              border: selected ? "2px solid " + BRAND.primary : "2px solid #CCC",
              background: selected ? BRAND.primary : "#fff",
              display: "flex", alignItems: "center", justifyContent: "center",
              flexShrink: 0,
            }}>
              {selected && <div style={{ width: "8px", height: "8px", borderRadius: "50%", background: "#fff" }} />}
            </div>
            <div style={{ flex: 1 }}>
              <div style={{ fontWeight: 600, fontSize: "15px", color: "#1A1A1A" }}>
                {"$" + t.price}
                <span style={{ fontWeight: 400, color: "#888", fontSize: "14px", marginLeft: "8px" }}>
                  {t.description}
                </span>
              </div>
            </div>
          </div>
        );
      })}
      <div style={{ marginTop: "16px" }}>
        <label style={LABEL_STYLE}>Which yard sign would you like?</label>
        <select
          value={yardSign}
          onChange={function(e) { onYardSignChange(e.target.value); }}
          style={{ ...INPUT_STYLE, background: "#fff", cursor: "pointer" }}
        >
          {YARD_SIGN_OPTIONS.map(function(o) {
            return <option key={o} value={o}>{o}</option>;
          })}
        </select>
      </div>
    </div>
  );
}
